import createVueComponent from '../createVueComponent';
export default createVueComponent('minus', 'IconMinus', [
  ['path', { d: 'M5 12l14 0', key: 'svg-0' }],
]);
